<div class="badge" (click)="goPage()">
  <ion-icon name="notifications"></ion-icon>
  <ng-container>
    <ng-template [ngIf]="notification$">
      <ion-label>{{notification$}}</ion-label>
    </ng-template>
  </ng-container>
</div>
